import { GLOBALS } from "config";

export function RentalOrBuy() {
  return <>{GLOBALS.IS_RENTAL ? "レンタル" : "購入"}</>;
}
